import './payment-summary.scss';
import InputKMQ from "../../../../../components/UI/Input/InputKMQ";
import ButtonKMQ from "../../../../../components/UI/Button/ButtonKMQ";
import React, {useEffect, useState} from "react";
import {useMutateApplyPromo} from "../../../../../api/payment/useMutateApplyPromo";
import {useParams} from "react-router-dom";
import LineSeparator from "../../../../../components/UI/LineSeparator/LineSeparator";
import Loading from "../../../../../components/UI/Loading/Loading";
import IconUp from "../../../../../assets/icons/UI/select/arrow-up-white.svg";
import IconDown from "../../../../../assets/icons/UI/select/arrow-down-white.svg";

export interface ICartItem {
  name: string,
  price: number,
  quantity: number,
  additional_fields: any
}

interface ICart {
  items: ICartItem[]
  subtotal: number
  tax: number
  tax_type: string
  total: number
}

const PaymentSummary = ({cartData, refetchCart}: { cartData: ICart, refetchCart: () => void }) => {
  const {session_id} = useParams();
  const [promo, setPromo] = useState<string>('');
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const {
    mutate: applyPromo,
    isSuccess: isSuccessPromo,
    isPending,
  } = useMutateApplyPromo({payment_intent_id: session_id});

  const isMobile = window.innerWidth <= 1024;

  useEffect(() => {
    if (isSuccessPromo) {
      refetchCart();
    }
  }, [isSuccessPromo])

  if (!cartData) {
    return null;
  }

  return <div className={'payment-summary'}>
    <Loading loading={isPending}/>
    <div className={`payment-summary-header ${isOpen ? '' : 'payment-summary-header-closed'}`}
         onClick={() => setIsOpen(!isOpen)}>
      Summary

      {isMobile
        ? <img
          src={isOpen ? IconUp : IconDown}
          alt={isOpen ? 'close-arrow' : 'open-arrow'}
          className={'payment-summary-header-arrow'}
        />
        : null
      }
    </div>
    <div className={`payment-summary-body${isOpen ? '' : '-closed'}`}>
      <div className={'payment-summary-cart'}>
        <div className={'payment-summary-cart-title'}>
          Your items
        </div>
        {
          cartData.items.map((item: ICartItem, index: number) =>
            <div className={'payment-summary-cart-item'} key={index}>
              <div className={'payment-summary-cart-item-name'}>
                <div className={'payment-summary-cart-item-name-course'}>
                  {item.name}
                </div>
                <div className={'payment-summary-cart-item-name-program'}>
                  {item.additional_fields?.program_when_added_cart?.name ?? ""}
                </div>
              </div>
              <div className={'payment-summary-cart-item-price'}>
                CAD${item.price.toFixed(2)}
              </div>
            </div>)
        }
      </div>
      <div className={'payment-summary-promo'}>
        <InputKMQ
          value={promo}
          onChange={(e) => setPromo(e.target.value)}
          type={'text'}
          placeholder={'Have a promo code?'}
        />
        <ButtonKMQ onClick={() => applyPromo({promo_code: promo})}>
          Apply
        </ButtonKMQ>
      </div>
      <div className={'payment-summary-total'}>
        <div className={'payment-summary-total-subtotal'}>
        <span className={'payment-summary-total-subtotal-text'}>
          Subtotal
        </span>
          <span className={'payment-summary-total-subtotal-price'}>
          CAD${cartData.subtotal.toFixed(2)}
        </span>
        </div>
        <div className={'payment-summary-total-tax'}>
        <span className={'payment-summary-total-tax-text'}>
          {cartData.tax_type}
        </span>
          <span className={'payment-summary-total-tax-price'}>
          CAD${cartData.tax.toFixed(2)}
        </span>
        </div>
        <LineSeparator/>
        <div className={'payment-summary-total-due'}>
        <span className={'payment-summary-total-due-text'}>
          Total due
        </span>
          <span className={'payment-summary-total-due-price'}>
          CAD${cartData.total.toFixed(2)}
        </span>
        </div>
      </div>
    </div>
  </div>
}

export default PaymentSummary;